import ImgTag from '../ImgTag'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { ImageLinks } from '../../constants/image-link'

interface Props {
  distribution: {
    name: string
    type: string
    url: string
  } | undefined

}


const DistrubuteChannelTag = (props: Props) => {
  const { distribution } = props
  if (!distribution) {
    return <></>
  }
  const logo = ImageLinks?.[`LOGO_${distribution?.type.toUpperCase()}` as keyof typeof ImageLinks]
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      mb: 1,
      backgroundColor: '#e1f5fa',
      padding: '5px',
      borderRadius: 1,
    }}>
      {logo &&
        <ImgTag imageUrl={logo} name={distribution?.name || ''} size={30} />
      }
      <Typography variant="subtitle2" color="info.main" sx={{ marginLeft: 1 }}>
        {distribution?.name || ''}
      </Typography>
    </Box>
  )
}

export default DistrubuteChannelTag
